import { DocumentLandscapeData24Regular } from '@fluentui/react-icons'
import { Button, TableCellLayout } from '@fluentui/react-components'
import { RestSchemas } from '@/contexts/QueryProvider'
import { MessagesStorageStorageFileType } from '@/util/enums'
import { useState } from 'react'
import { OverlayDrawerComponent } from '@/ui/OverlayDrawerComponent/OverlayDrawerComponent'
import { EntityFilesList } from '../../EntityFilesList'
import { useGetSearchParam } from '@/hooks'

type MessagesWorkspacesEntity = RestSchemas['Messages.Workspaces.Entity']

export function AssetsCellContent({ entity }: { entity: MessagesWorkspacesEntity }) {
  const workspaceId = useGetSearchParam<number>('subscriptionId')
  const [manageDataAssetsOpen, setManageDataTemplatesOpen] = useState(false)
  if (!workspaceId) return null
  return (
    <>
      <TableCellLayout>
        {entity.dataAssetFileCount}

        <Button
          appearance="subtle"
          icon={<DocumentLandscapeData24Regular />}
          onClick={(_b) => {
            setManageDataTemplatesOpen(true)
          }}
        />
      </TableCellLayout>

      <OverlayDrawerComponent
        open={manageDataAssetsOpen}
        setOpen={setManageDataTemplatesOpen}
        size="medium"
        title="Manage Entity Data Assets"
        content={
          <EntityFilesList
            onSubmit={() => setManageDataTemplatesOpen(false)}
            workspaceId={workspaceId}
            selectedEntity={entity}
            fileType={MessagesStorageStorageFileType.Result}
          />
        }
      />
    </>
  )
}
